import {Component, OnInit, OnDestroy} from '@angular/core';

import {CloudApiService} from "../../services/cloud-api.service";
import {UserSessionService} from "../../services/user-session.service";

import {DashboardDto} from "../../services/dtos/dashboard.dto";
import {SearchDto} from "../../services/dtos/search.dto";

import moment = require("moment");
import {NgbPopoverConfig} from '@ng-bootstrap/ng-bootstrap';
import {Observable} from "rxjs";

enum State {
    None,
    Loading,
    Ready
}

@Component({
    selector: 'occupancy',
    template: require('./occupancy.component.html'),
    styles: [ require('./occupancy.component.css') ],
    providers: [NgbPopoverConfig]
})
export class OccupancyComponent implements OnInit, OnDestroy {
    states = State;
    state: State = State.None;
    errorMessage: string;

    dashboardData: DashboardDto = new DashboardDto();

    private pollingTimerId: number;

    constructor(
        private userSession: UserSessionService,
        private cloudApiService: CloudApiService,
        config: NgbPopoverConfig
    ) {
        config.placement = 'left';
        config.triggers = 'hover'
    }

    public ngOnInit(): void {

        this.userSession.library.subscribe(library => {
            this.state = State.Loading;
            if (library)
                this.updateData();
        });

    }

    public ngOnDestroy(): void {
    }

    public updateData(showLoading: boolean = true): void {
        this.errorMessage = null;
        if (showLoading)
            this.state = State.Loading;

        this.retrieveStatistics().subscribe(() => {
            this.retrieveReportData().subscribe(() =>{
                this.state = State.Ready;
            });
        });

        // Refresh report data every 30 seconds
        window.clearTimeout(this.pollingTimerId);
        this.pollingTimerId = window.setTimeout(() => {
            this.updateData(false);
        }, 30 * 1000);
    }

    private retrieveStatistics(): Observable<void> {
        let searchQuery = this.createSearchQuery();
        return this.cloudApiService.getDashboard(this.userSession.branchId, searchQuery)
            .map(dashboard => {
                this.dashboardData = new DashboardDto().fromObject(dashboard);
            })
            .catch(error => this.handleError(error));
    }

    private retrieveReportData(): Observable<boolean> {
        let searchQuery = this.createSearchQuery();
        return this.cloudApiService.getDashboardReport(this.userSession.branchId, searchQuery)
            .map(reportData => {
                let gateLabels: string[] = [];
                let gateData: any[] = [{data: [], label: 'In'}, {data: [], label: 'Out'}];

                for (let data of reportData) {
                    gateLabels.push(moment.utc(data.dateTimeUtc).local().format('h:mm a'));
                    gateData[0].data.push(data.totalInCount);
                    gateData[1].data.push(data.totalOutCount);
                }

                return true;
            })
            .catch(error => this.handleError(error));
    }

    private handleError(error: any): Observable<any> {
        this.errorMessage = error;
        this.state = State.None;
        return Observable.throw(error);
    }

    private createSearchQuery(): SearchDto {
        let searchQuery = new SearchDto();

        searchQuery.fromDateUtc = moment().startOf('day').toDate();
        searchQuery.toDateUtc = moment(searchQuery.fromDateUtc).add({'hours': 24}).toDate();

        return searchQuery;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/components/occupancy/occupancy.component.ts